module.exports = __webpack_public_path__ + "img/criacao_solicitacoes.a3d31b6e.gif";